import { Progress as ProgressPrimitive } from '@base-ui/react/progress';
import { ProgressIndicator, ProgressTrack } from 'components/ui/progress';
import { t } from 'utils/getTranslations';

/** The top-of-page loading bar. */
export default function Loader() {
    return (
        <ProgressPrimitive.Root
            value={null}
            aria-label={t('loading')}
            className="fixed inset-x-0 top-0 z-(--z-blocking-loader)"
        >
            <ProgressTrack className="new:bg-primary-tint h-1.5 rounded-none">
                <ProgressIndicator className="loading-bar-sweep w-full rounded-full transition-none" />
            </ProgressTrack>
        </ProgressPrimitive.Root>
    );
}
